import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import icons from "../../icons.config";
import { forgotPasswordApi,verifyForgotOtpApi } from "../../Providers/authProvider";

const ForgotPassword = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Timer effect
  useEffect(() => {
    if (otpSent && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [otpSent, timeLeft]);

  // Send OTP API Call
  const handleSendOtp = async () => {
    if (phone.length !== 10 || !/^\d{10}$/.test(phone)) {
      setError("Phone number must be exactly 10 digits.");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await forgotPasswordApi(phone);
      setOtpSent(true);
      setMessage(response.message || `OTP sent to ${phone}`);
      setTimeLeft(300);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP API Call
  const handleVerifyOtp = async () => {
    if (!otp) {
      setError("Please enter the OTP.");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await verifyForgotOtpApi(phone, otp);
      setMessage(response.message || "OTP Verified Successfully.");
      navigate("/reset-password"); // Redirect to Reset Password page
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="relative min-h-screen flex items-center justify-center bg-tertiary top-10 overflow-hidden">
        <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-10 z-40">
          <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
        </div>
        <div className="hidden lg:block absolute left-8 top-20 z-10">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
        </div>

        {/* Forgot Password Box */}
        <div className="relative z-10 w-full max-w-md bg-tertiary px-8">
          <h2 className="text-center text-3xl font-outfit text-primary1 font-light mb-8">FORGOT PASSWORD</h2>
          {error && <p className="text-hcolor font-poppins font-light text-center mb-1">{error}</p>}
          {message && <p className="text-green-500 font-poppins font-light text-center mb-1">{message}</p>}

          {/* Phone Input */}
          <div className="mb-0">
            <label htmlFor="phone" className="relative left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-3">
              PHONE
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => {
                const input = e.target.value.replace(/\D/g, "");
                if (input.length <= 10) setPhone(input);
              }}
              placeholder="Enter your phone number"
              maxLength={10}
              className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-sm focus:outline-none focus:ring-2 focus:ring-primary1"
              disabled={otpSent}
            />

            {/* Send OTP Button */}
            <div className="flex justify-end mt-2 font-poppins font-light">
              <button 
                onClick={handleSendOtp} 
                className={`text-sm underline ${otpSent ? 'text-secondary' : 'text-hcolor'}`}
                disabled={otpSent || loading} 
              >
                {loading ? "Sending..." : "Send OTP"}
              </button>
            </div>
          </div>

          {/* OTP Input */}
          <div className="mb-8">
            <label htmlFor="otp" className="relative left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-3">
              OTP
            </label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter your OTP"
              className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-sm focus:outline-none focus:ring-2 focus:ring-primary1"
              disabled={!otpSent}
            />
          </div>

          {/* Verify OTP Button */}
          <button
            onClick={handleVerifyOtp}
            className="w-full bg-hcolor text-tertiary px-6 py-3 text-sm font-normal hover:bg-tertiary hover:border-2 hover:text-hcolor focus:outline-none focus:ring-2 focus:ring-primary1"
            disabled={loading}
          >
            {loading ? "Verifying..." : "VERIFY OTP"}
          </button>

          {/* Resend OTP & Timer */}
          <div className="text-center mt-6 space-y-4">
            <p className="text-sm text-hcolor">
              {timeLeft > 0 ? `Resend OTP in ${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(2, "0")}` : (
                <span className="text-primary1 cursor-pointer underline font-light" onClick={handleSendOtp}>
                  Resend OTP
                </span>
              )}
            </p>
            <p className="text-sm text-hcolor">
              Having trouble? <a href="/help" className="text-primary1 underline">Get Help</a>
            </p>
          </div>
        </div>
      </div>
      <FooterDoodles />
      <Footer />
    </>
  );
};

export default ForgotPassword;
